import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@roger/ui-components';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';

const Testing: React.FC = () => {
  const navigate = useNavigate();

  const testingOptions = [
    {
      id: 'x12-270',
      title: 'X12 270 Testing',
      description:
        'Generate X12 270 eligibility inquiry messages and submit to Waystar',
      status: 'active',
      icon: '🔍',
    },
    {
      id: 'stedi-270',
      title: 'Stedi 270 Testing',
      description:
        "Test eligibility checks using Stedi's modern JSON API format",
      status: 'active',
      icon: '🌐',
    },
    {
      id: 'stedi-cob',
      title: 'Stedi COB Testing',
      description: "Test coordination of benefits (COB) using Stedi's API",
      status: 'active',
      icon: '🌐',
    },
    {
      id: 'stedi-837i',
      title: 'Stedi 837I Testing',
      description:
        "Test institutional claim submissions using Stedi's JSON API format",
      status: 'active',
      icon: '🏥',
    },
    {
      id: 'x12-837',
      title: 'X12 837 Testing',
      description: 'Test X12 837 healthcare claim submission',
      status: 'active',
      icon: '📄',
    },
    {
      id: 'x12-835',
      title: 'X12 835 Testing',
      description: 'Test X12 835 healthcare claim payment/advice processing',
      status: 'active',
      icon: '💰',
    },
    {
      id: 'sentry',
      title: 'Sentry Integration Testing',
      description:
        'Test Sentry error tracking, user context, and breadcrumb functionality',
      status: 'active',
      icon: '🐛',
    },
  ];

  const handleCardClick = (option: (typeof testingOptions)[0]) => {
    if (option.status === 'active') {
      navigate(`/testing/${option.id}`);
    }
  };

  return (
    <div className='container mx-auto p-6 space-y-6'>
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-3xl font-bold'>Testing</h1>
          <p className='text-muted-foreground'>
            Test various X12 transactions and system functionality
          </p>
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {testingOptions.map(option => (
          <Card
            key={option.id}
            className={`cursor-pointer transition-all duration-200 hover:shadow-lg ${
              option.status === 'active'
                ? 'hover:border-primary'
                : 'opacity-60 cursor-not-allowed'
            }`}
            onClick={() => handleCardClick(option)}
          >
            <CardHeader>
              <div className='flex items-center space-x-3'>
                <span className='text-2xl'>{option.icon}</span>
                <div>
                  <CardTitle className='text-lg'>{option.title}</CardTitle>
                  {option.status === 'coming-soon' && (
                    <span className='inline-block px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded-full'>
                      Coming Soon
                    </span>
                  )}
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className='text-sm leading-relaxed'>
                {option.description}
              </CardDescription>
              {option.status === 'active' && (
                <Button
                  className='w-full mt-4'
                  onClick={e => {
                    e.stopPropagation();
                    navigate(`/testing/${option.id}`);
                  }}
                >
                  Open Testing
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Testing;
